/**
 * @Description Action types for
 * @FileName repReActionTypes.js
 * @Author pgoutam
 * @CreatedOn 16 Jan 23
 * @IssueID 224
 */

export const repTempActionTypes = {
  LOG_REPORT_TEMP_LIST_REQUEST: 'LOG_REPORT_TEMP_LIST_REQUEST',
  GET_REPORT_TEMP_CATEGORY_REQUEST: 'GET_REPORT_TEMP_CATEGORY_REQUEST',

  GET_REPORT_TEMP_LIST_REQUEST: 'GET_REPORT_TEMP_LIST_REQUEST',
  GET_REPORT_TEMP_LIST_RESPONSE: 'GET_REPORT_TEMP_LIST_RESPONSE',

  GET_REPORT_TEMP_TEMPLATE_REQUEST: 'GET_REPORT_TEMP_TEMPLATE_REQUEST',
  GET_REPORT_TEMP_TEMPLATE_RESPONSE: 'GET_REPORT_TEMP_TEMPLATE_RESPONSE',

  GET_REPORT_TEMP_LIST_ERROR: 'GET_REPORT_TEMP_LIST_ERROR',
  GET_REPORT_TEMP_DATASOURCE_LIST_REQUEST: 'GET_REPORT_TEMP_DATASOURCE_LIST_REQUEST',
  GET_REPORT_TEMP_DATASOURCE_LIST_RESPONSE: 'GET_REPORT_TEMP_DATASOURCE_LIST_RESPONSE',
  GET_REPORT_TEMP_DATASOURCE_LIST_ERROR: 'GET_REPORT_TEMP_DATASOURCE_LIST_ERROR',
  UPDATE_REPORT_TEMP_COLUMN_CONFIG: 'UPDATE_REPORT_TEMP_COLUMN_CONFIG',
  UPDATE_REPORT_TEMP_FILTER_CONFIG: 'UPDATE_REPORT_TEMP_FILTER_CONFIG',
  UPDATE_REPORT_TEMP_TABLE_CONFIGURATION: 'UPDATE_REPORT_TEMP_TABLE_CONFIGURATION',
  SET_REPORT_TEMP_DETAILS_RESPONSE: 'SET_REPORT_TEMP_DETAILS_RESPONSE',

  GET_REPORT_TEMP_DATASOURCE_FIELD_REQUEST: 'GET_REPORT_TEMP_DATASOURCE_FIELD_REQUEST',
  SET_REPORT_TEMP_DATASOURCE_FEILD_RESPONSE: 'SET_REPORT_TEMP_DATASOURCE_FEILD_RESPONSE',
  // remove user default filter from redux stotre
  REMOVE_REPORT_TEMP_USER_DEFAULT_FILTER: 'REMOVE_REPORT_TEMP_USER_DEFAULT_FILTER',

  UPDATE_REPORT_TEMP_DATASOURCE: 'UPDATE_REPORT_TEMP_DATASOURCE',
  // Reset store
  RESET_REPORT_TEMP_STORE: 'RESET_REPORT_TEMP_STORE',
  // Export List for BCR
  GET_REPORT_TEMP_EXPORT_REQUEST: 'GET_REPORT_TEMP_EXPORT_REQUEST',
  // Update Server Error Section
  SS_RESET_SERVER_VALUE: 'SS_RESET_SERVER_VALUE',
  GET_REPORT_TEMP_GRIDLIST_RESPONSE: 'GET_REPORT_TEMP_GRIDLIST_RESPONSE',
  SS_SAVE_TEMPLATE: 'SS_SAVE_TEMPLATE',
  SS_UPDATE_TEMPLATE: 'SS_UPDATE_TEMPLATE',
  SS_SAVE_UPDATE_TEMP_RESPONSE: 'SS_SAVE_UPDATE_TEMP_RESPONSE',
  SS_RESET_REPORT_TEMPLATE: 'SS_RESET_REPORT_TEMPLATE',
  GET_REPORT_CENTER_LIST_REQUEST: 'GET_REPORT_CENTER_LIST_REQUEST',
  SET_REPORT_CENTER_LIST_REQUEST: 'SET_REPORT_CENTER_LIST_REQUEST',
  GET_REPORT_CENTER_LIST_REQUEST_BY_ID: 'GET_REPORT_CENTER_LIST_REQUEST_BY_ID',
  SET_REPORT_CENTER_LIST_REQUEST_BY_ID: 'SET_REPORT_CENTER_LIST_REQUEST_BY_ID',
  RESET_REPORT_CENTER_LIST_REQUEST_BY_ID: 'RESET_REPORT_CENTER_LIST_REQUEST_BY_ID',

  GET_SHARE_REPORT_TEMPLATE_REQUEST: 'GET_SHARE_REPORT_TEMPLATE_REQUEST',
  GET_SHARE_REPORT_TEMPLATE_RESPONSE: 'GET_SHARE_REPORT_TEMPLATE_RESPONSE',
  SAVE_SHARE_REPORT_TEMPLATE_REQUEST: 'SAVE_SHARE_REPORT_TEMPLATE_REQUEST',
  SAVE_SHARE_REPORT_TEMPLATE_RESPONSE: 'SAVE_SHARE_REPORT_TEMPLATE_RESPONSE',
  RESET_SHARE_REPORT_TEMPLATE_STORE: 'RESET_SHARE_REPORT_TEMPLATE_STORE',
  SHARE_REPORT_TEMPLATE_ERROR: 'SHARE_REPORT_TEMPLATE_ERROR',

  // Delete Report Template
  DELETE_REPORT_TEMPLATE_REQUEST: 'DELETE_REPORT_TEMPLATE_REQUEST',
  DELETE_REPORT_TEMPLATE_RESPONSE: 'DELETE_REPORT_TEMPLATE_RESPONSE',
  DELETE_REPORT_TEMPLATE_RESET: 'DELETE_REPORT_TEMPLATE_RESET',
  DELETE_REPORT_TEMPLATE_ERROR: 'DELETE_REPORT_TEMPLATE_ERROR',

  GET_REPORT_SCHEDULE_REQUEST: 'GET_REPORT_SCHEDULE_REQUEST',
  GET_REPORT_SCHEDULE_RESPONSE: 'GET_REPORT_SCHEDULE_RESPONSE',
  GET_REPORT_SCHEDULE_ERROR: 'GET_REPORT_SCHEDULE_ERROR',
  GET_REPORT_SCHEDULE_RESET: 'GET_REPORT_SCHEDULE_RESET',

  SAVE_REPORT_SCHEDULE_REQUEST: 'SAVE_REPORT_SCHEDULE_REQUEST',
  SAVE_REPORT_SCHEDULE_RESPONSE: 'SAVE_REPORT_SCHEDULE_RESPONSE',
  SAVE_REPORT_SCHEDULE_ERROR: 'SAVE_REPORT_SCHEDULE_ERROR',
  SAVE_REPORT_SCHEDULE_RESET: 'SAVE_REPORT_SCHEDULE_RESET',
};
